"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeviceDetection = exports.useOnClickOutside = exports.useOnKeyPress = exports.useBodyLock = void 0;
var use_body_lock_1 = require("./use-body-lock");
Object.defineProperty(exports, "useBodyLock", { enumerable: true, get: function () { return use_body_lock_1.useBodyLock; } });
var use_on_key_press_1 = require("./use-on-key-press");
Object.defineProperty(exports, "useOnKeyPress", { enumerable: true, get: function () { return use_on_key_press_1.useOnKeyPress; } });
var use_on_click_outside_1 = require("./use-on-click-outside");
Object.defineProperty(exports, "useOnClickOutside", { enumerable: true, get: function () { return use_on_click_outside_1.useOnClickOutside; } });
var use_device_detection_1 = require("./use-device-detection");
Object.defineProperty(exports, "useDeviceDetection", { enumerable: true, get: function () { return use_device_detection_1.useDeviceDetection; } });
//# sourceMappingURL=index.js.map